import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
// import Grid from '@material-ui/core/Grid'
import Variables from 'components/TemplateForm/Variables/Variables'
import styles from 'components/AddOrEditTaskPage/styles'

export default connect(
  state => ({ navDisplayed: state.email.bottomNavigationDisplayed }),
  null
)(
  withStyles(styles)(({ classes, navDisplayed }) => (
    <Variables />
  ))
)
